import { useHandleMainDetailsScreenNavigation } from '@v2/pages/common/hooks/useHandleMainDetailsScreenNavigation';
import { JobDetailsScreenName } from '@v2/pages/job/navigation/config';
import { JobDetailsScreen } from '@v2/pages/job/common/enums/jobDetails.enum';
import { BatchDetailsScreenName } from '@v2/pages/batch/details/navigation/config';
import { BatchDetailsScreen } from '@v2/pages/batch/details/common/enums/batchDetails.enum';
import { LevelSubScreen, Perspective } from '@v2/pages/common/enums';
import { OperationSearchItem } from '@interfaces/search';

export const usePlanboardJobNavigation = (item: OperationSearchItem) => {
  const { navigateToMainDetailsScreen } = useHandleMainDetailsScreenNavigation();

  const navigateToGeneral = () => {
    navigateToMainDetailsScreen({
      mainScreen: JobDetailsScreenName,
      subScreen: JobDetailsScreen.JOBS,
      levelSubScreen: LevelSubScreen.GENERAL,
      params: {
        perspective: Perspective.JOBS,
        productionOperationId: item.productionOperationId,
        selectedProductionOperationId: item.productionOperationId,
        productionOrderId: item.productionOrderId,
        keepList: true,
      },
    });
  };

  const navigateToDocuments = () => {
    navigateToMainDetailsScreen({
      mainScreen: JobDetailsScreenName,
      subScreen: JobDetailsScreen.JOBS,
      levelSubScreen: LevelSubScreen.DOCUMENTS,
      params: {
        perspective: Perspective.JOBS,
        productionOperationId: item.productionOperationId,
        selectedProductionOperationId: item.productionOperationId,
        productionOrderId: item.productionOrderId,
        selectedImageKey: item.imageHash,
        keepList: true,
      },
    });
  };

  const navigateToBatch = () => {
    const linkedNcFile = item.linkedNcFiles?.find(
      (ncFile) => ncFile.productionBatchId != null
    );
    if (!linkedNcFile) {
      navigateToGeneral();
      return;
    }

    navigateToMainDetailsScreen({
      mainScreen: BatchDetailsScreenName,
      subScreen: BatchDetailsScreen.JOBS,
      levelSubScreen: LevelSubScreen.GENERAL,
      params: {
        perspective: Perspective.BATCH,
        batchNumber: linkedNcFile.productionBatchNumber,
        batchId: linkedNcFile.productionBatchId,
        ncFileStatus: linkedNcFile.ncFileStatus,
        productionOperationId: item.productionOperationId,
        keepList: true,
      },
    });
  };

  return { navigateToGeneral, navigateToDocuments, navigateToBatch };
};
